module.exports = new __parcel__URL__("artifact_0010.9d3218b6.png").toString();